import { CommonModule } from '@angular/common';
import { Component, ElementRef, viewChild } from '@angular/core';
import { Desktop } from 'src/app/core/api/models';

import { AppStateService } from 'src/app/core/services/app-state.service';
import { AppConfigService } from 'src/app/core/services/config.service';
import { ThemeColorDirective } from 'src/app/core/utils/theme/theme-color.directive';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { ClientDataInitializerService } from '../../../core/services/authentication/client-data-initializer.service';
import { AppIntroService } from './app-intro.service';
@Component({
    selector: 'app-intro',
    imports: [CommonModule, TranslationModule, ThemeColorDirective],
    templateUrl: './app-intro.component.html',
    styleUrls: ['./app-intro.component.scss']
})
export class AppIntroComponent {
  readonly splashScreen = viewChild<ElementRef>('splashScreen');
  isOwnerPanel: boolean = false;
  agentLogo: string;
  agentName: string;
  desktop: Desktop;
  appUrl: string = AppConfigService.config.appUrl;

  get Desktop() {
    return Desktop;
  }

  constructor(
    private appIntroService: AppIntroService,
    private clientDataService: ClientDataInitializerService
  ) {}

  ngOnInit() {
    if (window.location.origin == this.appUrl) this.isOwnerPanel = true;
    this.appIntroService.init(this.splashScreen());

    this.agentLogo = this.clientDataService.getCurrentClientData?.agentLogo;
    this.agentName = this.clientDataService.getCurrentClientData?.name;

    this.desktop = AppStateService.appTheme;
  }

  onRefresh() {
    location.reload();
  }
}
